var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-card-text',[_vm._t("header"),_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"540px"}})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }